import * as Yup from "yup";
const ErrorString = "This field is required";

export const reportPermissionValidation = Yup.object().shape({
    
    reportName: Yup.string().nullable().required(ErrorString),
    category:Yup.string().nullable().required(ErrorString),
    description: Yup.string().trim().required(ErrorString),    
});